import { TokenLogout } from 'API/Logout/logout';
import axios from 'axios';
const url = process.env.REACT_APP_BANKVERIFY_URL;
const fileurl = process.env.REACT_APP_APPROVAL_URL;

export const GetAllVendorOnboardingRequest = async (setIsLoading, setData, handleAlertOpen, type, page, limit) => {
  try {
    setIsLoading(true);
    await axios
      .post(
        `${url}/procurement/vendor/updated/all/list`,
        { vendor_status: type },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          },
          params: {
            page: page,
            limit: limit
          }
        }
      )
      .then((res) => {
        setIsLoading(false);
        setData(res.data);
      })
      .catch((error) => {
        setIsLoading(false);
        if (error.response && error.response.data.error === 'No vendors found.') {
          console.log('No vendors found');
          setData([]);
        } else {
          handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong', 'error');
          TokenLogout(error);
        }
      });
  } catch (error) {
    setIsLoading(false);
    if (error.response && error.response.data.error === 'No vendors found.') {
      console.log('No vendors found');
    } else {
      handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong', 'error');
      TokenLogout(error);
    }
  }
};

export const GetAllVendors = async (setData, setIsLoading, name, company_name, handleAlertOpen, page, limit, status) => {
  try {
    setIsLoading(true);
    await axios
      .post(
        `${url}/procurement/vendor/updated/all/list`,
        {
          vendor_status: status,
          vendor_name: name ? name : '',
          company_name: company_name ? company_name : ''
        },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          },
          params: {
            page: page,
            limit: limit
          }
        }
      )
      .then((res) => {
        setIsLoading(false);
        setData(res.data);
      });
    //     .catch((error)=>{
    //        setIsLoading(false)

    //     //    handleAlertOpen(error.response&&error.response.data.error?error.response.data.error:"Something went wrong","error")
    //    })
  } catch (error) {
    setIsLoading(false);
    if (error.response && error.response.data.error === 'No vendors found.') {
      console.log('No vendors found');
      setData(null);
    } else {
      handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong', 'error');
    }
    TokenLogout(error);
  }
};

export const GetAllVendorListForSelect = async (setData, setIsLoading, handleAlertOpen) => {
  try {
    setIsLoading(true);
    await axios
      .post(
        `${url}/procurement/vendor/approved/list/dropdown`,
        {},
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        setIsLoading(false);
        setData(res.data);
      });
  } catch (error) {
    setIsLoading(false);
    handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong', 'error');
    TokenLogout(error);
  }
};

export const UpdateRequestStatus = async (vendorCode, vendorStatus, id, setIsLoading, handleAlertOpen) => {
  try {
    setIsLoading(true);
    await axios
      .post(
        `${url}procurement/vendor/status/update`,
        {
          vendor_code: vendorCode ? vendorCode : '',
          vendor_status: vendorStatus,
          _id: id
        },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        setIsLoading(false);
        handleAlertOpen(res.data.message, 'success');
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      })
      .catch((error) => {
        setIsLoading(false);
        handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong', 'error');
      });
  } catch (error) {
    setIsLoading(false);
    handleAlertOpen(error && error.response && error.response.data.error ? error.response.data.error : 'Something went wrong', 'error');
  }
};

export const GetVendorImages = async (imageUrl, setImageFile, handleImageOpen, handleOpenAlert, setFileType, setIsLoading) => {
  try {
    setIsLoading(true);
    await axios
      .post(
        `${fileurl}/download`,
        { url: imageUrl },
        {
          responseType: 'arraybuffer'
        }
      )
      .then((response) => {
        const contentType = response.headers['content-type'];
        setIsLoading(false);
        if (response.status === 200) {
          console.log(response);
          const blob = new Blob([response.data], {
            type: response.headers['content-type']
          });
          const imageUrl = URL.createObjectURL(blob);

          if (contentType === 'application/pdf') {
            handleImageOpen();
            setImageFile(imageUrl);
            setFileType('pdf');
          } else if (contentType.startsWith('image/')) {
            handleImageOpen();
            setImageFile(imageUrl);
            setFileType('image');
          } else {
            fileExtension = `${name}.bin`;
          }
        }
      });
  } catch (error) {
    // console.log(error);
    setIsLoading(false);
    handleOpenAlert(error && error.response && error.response.data.error ? error.response.data.error : 'unable to open the image', 'error');
    TokenLogout(error);
  }
};

export const VendorInvoiceList = async (page, limit, Data, setVendorList, setIsLoading, setError, setTotalCount) => {
  setIsLoading(true);
  try {
    await axios
      .post(
        `${url}procurement/invoice/list`,
        { ...Data, page: page, limit: limit },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        setVendorList(res.data.all_invoice);
        setTotalCount(res.data.total_count);
        setIsLoading(false);
      })
      .catch((error) => {
        TokenLogout(error);
        setIsLoading(false);
        setError(error.response ? error.response.data.error : 'Something went wrong');
      });
  } catch (error) {
    TokenLogout(error);
    setIsLoading(false);
    setError(error.response ? error.response.data.error : 'Something went wrong');
  }
};

export const InvoiceStatementList = async (page, limit,Data, id, setInvoiceStatement, setIsLoading, setError, setTotalCount) => {
  setIsLoading(true);
  console.log('Data', Data);

  try {
    await axios
      .post(
        `${url}procurement/invoice/statement`,
        {
          // date_from: Data.date_from, date_to: Data.date_to,
          vendor_id: id, page: page, limit: limit
        },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        setInvoiceStatement(res.data.all_vendor_statement);
        setTotalCount(res.data.total_count);
        setIsLoading(false);
      })
      .catch((error) => {
        TokenLogout(error);
        setIsLoading(false);
        setError(error.response ? error.response.data.error : 'Something went wrong');
      });
  } catch (error) {
    TokenLogout(error);
    setIsLoading(false);
    setError(error.response ? error.response.data.error : 'Something went wrong');
  }
};
